/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/491/interface/api/cat_1806
 */

import { message } from 'ant-design-vue'
import {
  bizLog_get_biz_logs_post,
  bizLog_page_biz_logs_post,
  bizLog_get_history_biz_logs_post
} from 'server/modules/1806'

// 获取日志信息
export const bizLog_get_biz_logs_post_ = async function(params) {
  const { success, data, retInfo } = await bizLog_get_biz_logs_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取日志信息分页
export const bizLog_page_biz_logs_post_ = async function(params) {
  const { success, data, retInfo } = await bizLog_page_biz_logs_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取历史日志信息
export const bizLog_get_history_biz_logs_post_ = async function(params) {
  const { success, data, retInfo } = await bizLog_get_history_biz_logs_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
